<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="3">
        <RangeFilter
            :end="dateEnd"
            :start="dateStart"
            @getDates="getDates"
            :excludePeriod="excludePeriod"
            :defaultPeriod="defaultPeriod"
            :setDates="true"
            :disabled="loaded"
        />
      </v-col>
      <v-spacer></v-spacer>
      <last-time-updated :selectedDate="'updateOrders'" class=" mt-0 mt-md-4"/>
    </v-row>
    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg">
      <v-progress-linear
          indeterminate
          color="blue darken-2"
          v-if="loaded"
      ></v-progress-linear>
      <v-row class="pa-0">
        <v-col cols="12" md="3" class="d-flex justify-center">
          <div class="d-flex flex-column">
            <div><b class="pr-1">Total Orders: </b> {{ statistic.totalOrders | formatFloat }}</div>
            <div v-if="showFilteredStatistic" class="text-caption primary--text d-inline-flex justify-center"><b
                class="pr-1">Total Orders: </b> {{ statisticFiltered.totalOrders | formatFloat }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3" class="d-flex justify-center">
          <div class="d-flex flex-column">
            <div><b class="pr-1">Total Gallons: </b> {{ statistic.totalGallons | formatFloat }}</div>
            <div v-if="showFilteredStatistic" class="text-caption primary--text d-inline-flex justify-center"><b
                class="pr-1">Total Gallons: </b> {{ statisticFiltered.totalGallons | formatFloat }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3" class="d-flex justify-center">
          <div class="d-flex flex-column">
            <div><b class="pr-1">Total Revenue: </b> ${{ statistic.totalSalesPrice | formatPrice }}</div>
            <div v-if="showFilteredStatistic" class="text-caption primary--text d-inline-flex justify-center"><b
                class="pr-1">Total Revenue: </b> ${{ statisticFiltered.totalSalesPrice | formatPrice }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3" class="d-flex justify-center">
          <div class="d-flex flex-column">
            <div><b class="pr-1">Total Expenses: </b> ${{ statistic.totalExpenses | formatPrice }}</div>
              <div v-if="isShowROAS" class="text-caption primary--text d-inline-flex justify-center">
                  <b class="pr-1">ROAS: </b> {{ statisticFiltered.totalSalesPrice/statistic.totalExpenses | formatFloat }}
              </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="5" class="pb-0">
          <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn
            color="indigo"
            class="mt-3"
            dark
            depressed
            height='40'
            max-width='40'
            min-width='40'
            @click="cleanFilters"
        >
          <v-icon>
            mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>
      <v-row class="px-7 pb-0 pt-6">
        <v-col cols="12" md="6" lg="2" class="pa-0 mr-auto" v-for="e in autocompleteСards" :key="e.value">
          <v-autocomplete

              dense
              v-model="filtered[`${e.filtered}`]"
              :items="filters[`${e.filters}`]"
              :menu-props="{ maxHeight: '200' }"
              multiple
              outlined
              :class="['mr-md-1', {'v-input--is-focused primary--text' : filtered[`${e.filtered}`].length}]"
              @change="fetchFilters"

          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2 && !e.tooltip" text-color="grey darken-4" class="grey lighten-3">
                <span>{{ item }}</span>
              </v-chip>
              <span
                  v-if="index === 2 && !e.tooltip"
                  class="grey--text chip-counter"
              >
                (+{{
                  filtered[`${e.filtered}`].length - 2
                }} {{ (filtered[`${e.filtered}`].length - 2) > 1 ? 'others' : 'another' }})
              </span>
              <v-chip text-color="white" :class="item.value" v-if="e.tooltip">
                <span>{{ item.text }}</span>
              </v-chip>
            </template>
            <template v-slot:label>
              <p :class="filtered[`${e.filtered}`].length ? 'primary--text' : ''">{{ e.name }}</p>
            </template>
            <template v-slot:item="{ active, item, on, attrs }" v-if="e.tooltip">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters align="center">
                      <span>{{ item.text }}</span>
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-on="on" v-bind="attrs" :color="item.value" small>mdi-information-outline</v-icon>
                        </template>
                        <span v-html="item.tooltip"></span>
                      </v-tooltip>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6" lg="2" class="pa-0">
          <v-btn
              color="indigo"
              height="40"
              class="text--white"
              dark
              @click="hiddenAdditionalFilters = !hiddenAdditionalFilters"
          >
            {{ hiddenAdditionalFilters ? 'Show others' : 'Hide others' }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="px-7 pb-0 pt-6" v-if="!hiddenAdditionalFilters">
        <v-col cols="12" md="6" lg="2" class="pa-0" v-for="e in autocompleteOthersСards" :key="e.value">
          <v-autocomplete
              dense
              v-model="filtered[`${e.filtered}`]"
              :items="filters[`${e.filters}`]"
              :menu-props="{ maxHeight: '200' }"
              multiple
              outlined
              :class="['mr-md-1', {'v-input--is-focused primary--text' : filtered[`${e.filtered}`].length}]"
              @change="fetchFilters"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="grey darken-4" class="grey lighten-3">
                <span class="">{{ item }}</span>
              </v-chip>
              <span
                  v-if="index === 2"
                  class="grey--text chip-counter"
              >
                (+{{
                  filtered[`${e.filtered}`].length - 2
                }} {{ (filtered[`${e.filtered}`].length - 2) > 1 ? 'others' : 'another' }})
              </span>
            </template>
            <template v-slot:label>
              <p :class="filtered[`${e.filtered}`].length ? 'primary--text' : ''">{{ e.name }}</p>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-0 px-0 mt-4 rounded-lg">
      <v-card-title>
        <v-row class="pa-0">
          <v-col cols="12" class="d-flex justify-end pb-0 pt-0 mt-0 mt-md-4">
            <v-spacer></v-spacer>
            <vue-excel-xlsx
                :data="dataForExcel"
                :columns="columnsData"
                :filename="'Sales Report'"
                :sheetname="`${dateStart} ~ ${dateEnd}`"
            >
              <v-btn
                  height="39"
                  min-width="39px"
                  :disabled="dataFiltered.length === 0"
                  class="ml-auto mr-5 rounded-lg px-0"
                  color="white"
              >
                <ExportExcel/>
              </v-btn>
            </vue-excel-xlsx>
            <CustomColumns
                :currentValue="value"
                :currentCustomHeader="customHeader"
                :currentHeaders="headers"
                :settingsName="settingsName"
                @getCustomData="getCustomData"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <v-btn
                class="mx-2 scroll-btn btn-left-arrow"
                fab
                small
                @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
                class="mx-2 scroll-btn btn-right-arrow"
                fab
                small
                @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              :footer-props="{
                  'items-per-page-options': [10, 25, 50, 75, 100, -1]
                  }"
              :items-per-page="25"
              dense
              :headers="selectedHeaders"
              :items="dataFiltered"
              :page.sync="pagination.page"
              item-key="id"
              class="elevation-0 mt-2 table-main-container"
              :loading="loaded"
              loading-text="Loading... Please wait"
              :search="search"
              fixed-header
              height="609"
              @click:row="rowClick"
          >
            <template v-slot:header.order_lead_type="{ header }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>
                <v-list color="white">
                  <v-list-item v-for="item in filters.orderKeyword" :key="item.value">
                    <v-list-item-content>
                      <div class="d-flex">
                        <v-icon bottom
                                :color="`${item.value} darken-2`"
                                class="mr-2"
                        >
                          mdi-information-outline
                        </v-icon>
                        <v-list-item-title v-text="item.tooltip"></v-list-item-title>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tooltip>
            </template>
            <template v-slot:item.copper_info="{ item }">
              {{item.copper_info}}
              <br v-if="item.copper_info!=''"/>
              <v-icon
                    small
                    v-if="(role == 'Admin' || managementRight) && item.copper_people_id"
                    @click="updateCopperTags(item)"
                >
                  mdi-update
              </v-icon>
            </template>
            <template v-slot:item.copper_contact="{ item }">
              <span v-if="item.copper_contact > 0 ">Yes</span>
              <span v-if="item.copper_contact == 0">No</span>
            </template>
            <template v-slot:item.products="{ item }">
              <p style="width: 250px; margin-bottom: 0;" v-for="p in item.products" :key="p.id">
                {{ p.name + " - " + p.gallons + " gal." }}</p>
            </template>
            <template v-slot:item.sib_campaign_name="{ item }">
              <span v-if="item.sib_campaign_name"><a target="_blank"
                                                     :href="`https://my.sendinblue.com/camp/report/id/`+item.sib_id ">{{ item.sib_id }}. {{
                  item.sib_campaign_name
                }}</a></span>
              <span v-else> - </span>
            </template>
            <template v-slot:item.sp_campaign_name="{ item }">
              <span v-if="item.sp_campaign_name"><a target="_blank"
                                                     :href="`https://login.sendpulse.com/emailservice/tasks/stat/id/`+item.sp_id ">{{ item.sp_id }}. {{
                  item.sp_campaign_name
                }}</a></span>
              <span v-else> - </span>
            </template>
            <template v-slot:item.primary_email="{ item }">
              <span>{{ item.primary_email.toString().toLowerCase() }}</span>
            </template>
            <template v-slot:item.sale_price="{ item }">
              <span v-if="item.sale_price > 0 ">$ {{
                  item.sale_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}</span>
              <span v-if="item.sale_price == 0">0</span>
            </template>
            <template v-slot:item.sib_sent_date="{ item }">
              <span v-if="item.sib_sent_date">{{ new Date(item.sib_sent_date).toLocaleString() }}</span>
              <span v-else> - </span>
            </template>
            <template v-slot:item.sp_sent_date="{ item }">
              <span v-if="item.sp_sent_date">{{ new Date(item.sp_sent_date).toLocaleString() }}</span>
              <span v-else> - </span>
            </template>
            <template v-slot:item.gallons="{ item }">
              <span v-if="item.gallons > 0 ">{{ item.gallons.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</span>
              <span v-if="item.gallons == 0">0</span>
            </template>
            <template v-slot:item.order_lead_type="{ item }">
              <div style="text-align: left">
                  <button
                      v-if="item.leads_kc !== null"
                      style="display: flex;"
                      @click="openLeads(item)"
                  >
                    <v-icon bottom
                            :color="`${item.color} darken-2`"
                            class="flex-grow-0 flex-shrink-0"
                    >
                      mdi-information-outline
                    </v-icon>
                    <span :class="[item.leads_kc ? 'ml-2' : 'ml-8', 'text-left']">{{ item.order_lead_type }}</span>
                  </button>
                  <span v-if="item.leads_kc === null" :class="[item.leads_kc ? 'ml-2' : 'ml-8', 'text-left']" style="display: flex;">{{ item.order_lead_type }}</span>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex flex-column">
                <v-icon
                    small
                    v-if="(role == 'Admin' || managementRight)"
                    @click="openEditKeywordCampaign(item)"
                >
                  mdi-pencil
                </v-icon>
              </div>
            </template>
          </v-data-table>
          <v-dialog v-model="dialogSettings" persistent max-width="1000px">
            <v-card v-if="selectedOrder">
              <v-card-title>
                <span class="headline">Order Leads</span>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-container>
                  <v-row>
                    <v-data-table
                        v-if="selectedOrder.leads_kc"
                        :headers="[
                                {text: '', value: 'internal_keyword_id'},
                                {text: 'Type', value: 'type_kc'},
                                {text: 'Keyword', value: 'keyword'},
                                {text: 'Campaign', value: 'campaign'},
                                {text: 'Source', value: 'source'},
                                {text: 'Date', value: 'created_at'},
                                {text: 'ID', value: 'record_id'},
                                {text: 'Search Query', value: 'search_query'},
                                ]"
                        :sort-by="'created_at'"
                        :sort-desc="true"
                        :items="selectedOrder.leads_kc"
                        hide-default-footer
                        style="width: 100%"
                    >
                       <template v-slot:header.search_query="{ header }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              {{ header.text }}
                              <v-icon small>
                                mdi-information
                              </v-icon>
                            </span>
                          </template>
                          <div style="max-width: 400px">
                            The actual term somebody used in a search engine before clicking through to your website.
                          </div>
                        </v-tooltip>
                      </template>
                      <template v-slot:item.internal_keyword_id="{ item }">
                        <span v-if="item.internal_keyword_id > 0"><v-icon>mdi-check-circle-outline</v-icon></span>
                        <span v-else></span>
                      </template>
                      <template v-slot:item.created_at="{ item }">
                        <span v-if="item.created_at != '2021-01-01T00:00:00'">{{
                            new Date(Date.parse(item.created_at)).toLocaleString()
                          }}</span>
                        <span v-else></span>
                      </template>
                    </v-data-table>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelLeads">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
              v-model="dialogEditKeywordCampaign"
              max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                Keyword/Campaign for Order
              </v-card-title>
              <v-card-text>
                <v-autocomplete
                    v-model="keywordCampaignFormCampaignId"
                    :items="campaigns"
                    item-text="campaignName"
                    item-value="campaignId"
                    label="Campaign"
                >
                </v-autocomplete>
                <v-autocomplete
                    :loading="loadingKeywords"
                    v-model="keywordCampaignFormKeywordId"
                    :items="keywords"
                    item-text="keyword_text"
                    item-value="internal_keyword_id"
                    label="Keyword"
                ></v-autocomplete>

                <div v-if="this.keywordCampaignForm" class="mt-2">
                  <h3>Existing keywords for order</h3>
                  <div>
                    <div>
                      <table style="border: 1px solid #333; text-align: center; width: 100%">
                        <thead>
                        <tr>
                          <th style="border: 1px solid #333;">Campaign</th>
                          <th style="border: 1px solid #333;">Keyword</th>
                          <th style="border: 1px solid #333;">Type</th>
                          <th style="border: 1px solid #333;">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="kc in this.keywordCampaignForm.leads_kc" :key="kc.id">
                          <td style="border: 1px solid #333;">{{ kc.campaign == '' ? '-' : kc.campaign }}</td>
                          <td style="border: 1px solid #333;">{{ kc.keyword == '' ? '-' : kc.keyword }}</td>
                          <td style="border: 1px solid #333;"> {{ kc.type_kc }}</td>
                          <td style="border: 1px solid #333;" v-if="kc.type_kc == 'manual edit'"><a
                              @click="deleteManualKeyword(kc.id, kc.order_id)">Delete</a></td>
                          <td style="border: 1px solid #333;" v-else></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="closeEditKeywordCampaign"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="green darken-1"
                    text
                    :disabled="!keywordCampaignFormKeywordId"
                    @click="saveEditKeywordCampaign"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
              v-model="dialogEditCopperCompany"
              max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                Edit Copper Company
              </v-card-title>
              <v-card-text>
                <v-text-field v-model="copperCompanynForm"/>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="closeEditCopperCompany"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="green darken-1"
                    text
                    :disabled="copperCompanynForm ? copperCompanynForm.trim().length == 0: true"
                    @click="saveEditCopperCompany"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'
import LastTimeUpdated from "@/views/LastTimeUpdated";

export default {
  components: {
    LastTimeUpdated,
    RangeFilter,
    CustomColumns,
    ExportExcel
  },
  data() {
    return {
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      pagination: {
        page: 1
      },
      loaded: false,
      data: [],
      headers: [
        {text: 'Order Date', value: 'sale_date', class: 'black--text', filterable: false, sortable: true},
        {text: 'Hub Order ID', value: 'hub_order_id', class: 'black--text'},
        {text: 'Invoice ID', value: 'invoice_id', class: 'black--text'},
        {text: 'Order #', value: 'nop_commerce_id', class: 'black--text'},
        {text: 'PO #', value: 'qb_po_id', class: 'black--text'},
        {text: 'Hub User Type', value: 'customer_type', class: 'black--text'},
        {text: 'Copper Company Type', value: 'copper_customer_type', class: 'black--text'},
        {text: 'Copper Company Name', value: 'copper_company_name', class: 'black--text'},
        {text: 'Customer Name', value: 'customer_name', class: 'black--text'},
        {text: 'Customer Email', value: 'primary_email', class: 'black--text'},
        {text: 'Company Name', value: 'company_name', class: 'black--text'},
        {text: 'Shipping Address', value: 'ship_addr', class: 'black--text'},
        {text: 'All Unique Emails', value: 'all_emails', class: 'black--text'},
        {text: 'All Unique Phones', value: 'all_phones', class: 'black--text'},
        {text: 'CallRail Phone', value: 'call_rail_phone', class: 'black--text'},
        {text: 'Gallons', value: 'gallons', class: 'black--text', filterable: false},
        {text: 'Order Revenue', value: 'sale_price', class: 'black--text', filterable: false},
        {text: 'Order Leads', value: 'order_lead_type', class: 'black--text', filterable: false},
        {text: 'Created by Admin', value: 'is_created_by_admin', class: 'black--text'},
        {text: 'Copper Tag', value: 'copper_info', class: 'black--text'},
        {text: 'Copper Notes', value: 'copper_notes', class: 'black--text'},
        {text: 'Copper Contact', value: 'copper_contact', class: 'black--text'},
        {text: 'SiB Campaign', value: 'sib_campaign_name', class: 'black--text'},
        {text: 'SiB Sent Date', value: 'sib_sent_date', class: 'black--text'},
        {text: 'SP Campaign', value: 'sp_campaign_name', class: 'black--text'},
        {text: 'SP Sent Date', value: 'sp_sent_date', class: 'black--text'},
        {text: 'Products', value: 'products', class: 'black--text'},
        {text: 'Actions', value: 'actions', class: 'black--text'}
      ],
      value: [
        {text: 'Order Date', value: 'sale_date', class: 'black--text', filterable: false, sortable: true},
        {text: 'Hub Order ID', value: 'hub_order_id', class: 'black--text'},
        {text: 'Invoice ID', value: 'invoice_id', class: 'black--text'},
        {text: 'Order #', value: 'nop_commerce_id', class: 'black--text'},
        {text: 'PO #', value: 'qb_po_id', class: 'black--text'},
        {text: 'Hub User Type', value: 'customer_type', class: 'black--text'},
        {text: 'Copper Company Type', value: 'copper_customer_type', class: 'black--text'},
        {text: 'Copper Company Name', value: 'copper_company_name', class: 'black--text'},
        {text: 'Customer Name', value: 'customer_name', class: 'black--text'},
        {text: 'Customer Email', value: 'primary_email', class: 'black--text'},
        {text: 'Company Name', value: 'company_name', class: 'black--text'},
        {text: 'Shipping Address', value: 'ship_addr', class: 'black--text'},
        {text: 'All Unique Emails', value: 'all_emails', class: 'black--text'},
        {text: 'All Unique Phones', value: 'all_phones', class: 'black--text'},
        {text: 'CallRail Phone', value: 'call_rail_phone', class: 'black--text'},
        {text: 'Gallons', value: 'gallons', class: 'black--text', filterable: false},
        {text: 'Order Revenue', value: 'sale_price', class: 'black--text', filterable: false},
        {text: 'Order Leads', value: 'order_lead_type', class: 'black--text', filterable: false, width: '150px'},
        {text: 'Created by Admin', value: 'is_created_by_admin', class: 'black--text'},
        {text: 'Copper Tag', value: 'copper_info', class: 'black--text'},
        {text: 'Copper Notes', value: 'copper_notes', class: 'black--text'},
        {text: 'Copper Contact', value: 'copper_contact', class: 'black--text'},
        {text: 'SiB Campaign', value: 'sib_campaign_name', class: 'black--text'},
        {text: 'SiB Sent Date', value: 'sib_sent_date', class: 'black--text'},
        {text: 'SP Campaign', value: 'sp_campaign_name', class: 'black--text'},
        {text: 'SP Sent Date', value: 'sp_sent_date', class: 'black--text'},
        {text: 'Products', value: 'products', class: 'black--text'},
        {text: 'Actions', value: 'actions', class: 'black--text'}
      ],
      customHeader: ['sale_date', 'hub_order_id', 'invoice_id', 'nop_commerce_id', 'qb_po_id',
        'customer_type', 'copper_customer_type', 'customer_name', 'primary_email', 'company_name', 'ship_addr',
        'gallons', 'sale_price', 'order_lead_type', 'order_lead_source', 'search_query',
        'order_lead_keyword', 'order_lead_campaign', 'keyword', 'campaign', 'call_id',
        'web_inquiry_id', 'is_created_by_admin', 'client_id', 'copper_info', 'copper_contact', 'copper_notes',
        'sib_campaign_name', 'sib_sent_date', 'products', 'actions', 'all_emails', 'all_phones', 'call_rail_phone',
        'copper_company_name', 'sp_campaign_name', 'sp_sent_date',],
      selectedHeaders: [],
      filtered: {
        'order_lead_type': [],
        'order_lead_source': [],
        'customer_name': [],
        'copper_customer_type': [],
        'customer_type': [],
        'is_created_by_admin': [],
        'products': [],
        'id': [],
        'hub_order_id': [],
        'color': []
      },
      filters: {
        'leadTypeFilter': ['web inquiries'],
        'leadSourceFilter': [],
        'customerFilter': [],
        'customerType': [],
        'copperCompanyType': [],
        'createdByAdmin': [],
        'productName': [],
        'orderKeyword': [{
          text: "Paid leads",
          value: 'blue',
          tooltip: 'Paid leads. There is at least one order with keyword/campaign and internal_keyword_id > 0'
        },
          {
            text: "Mapping needed",
            value: 'red',
            tooltip: 'User has to do mapping manually. There is at least one order with keyword/campaign and internal_keyword_id = 0'
          },
          {
            text: "Other",
            value: 'grey',
            tooltip: 'There is no order with keyword/campaign and internal_keyword_id > 0'
          },
        ]
      },
      hiddenAdditionalFilters: true,
      search: '',
      statistic: {
        totalOrders: 0,
        totalGallons: 0,
        totalSalesPrice: 0,
        totalExpenses: 0
      },
      statisticFiltered: {
        totalOrders: 0,
        totalGallons: 0,
        totalSalesPrice: 0
      },
      settingsName: 'salesReport',
      dialogSettings: false,
      selectedOrder: null,
      dialogEditCopperCompany: false,
      copperCompanynForm: null,
      copperCompanynFormId: 0,
      dialogEditKeywordCampaign: false,
      keywordCampaignFormCampaignId: null,
      keywordCampaignFormKeywordId: null,
      managementRight: false,
      rights: [],
      role: null,
      campaigns: [],
      keywords: [],
      loadingKeywords: false,
      columnsData: [],
      selectedRows: [],
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
        isShowROAS:false,
      autocompleteСards: [
        {name: 'Copper Company Type', filtered: 'copper_customer_type', filters: 'copperCompanyType'},
        {name: 'Hub User Type Filter', filtered: 'customer_type', filters: 'customerType'},
        {name: 'Created by Admin', filtered: 'is_created_by_admin', filters: 'createdByAdmin'},
        {name: 'Product Type Filter', filtered: 'products', filters: 'productName'},
        {name: 'Order/Keyword Filter', filtered: 'color', filters: 'orderKeyword', tooltip: true}
      ],
      autocompleteOthersСards: [
        {name: 'Order Lead Type Filter', filtered: 'order_lead_type', filters: 'leadTypeFilter'},
        {name: 'Customer Filter', filtered: 'customer_name', filters: 'customerFilter'},
      ]
    }
  },
  watch: {
    dataFiltered: function () {
      this.pagination.page = 1
    },
    value(val) {
      this.selectedHeaders = val
      this.getHeaderForExcel()
    },
    keywordCampaignFormCampaignId(val) {
      this.loadingKeywords = true

      if (val == null) {
        this.loadingKeywords = false
        return
      }

      axios
          .get('/all/keyword/' + val)
          .then(response => {
            this.keywords = response.data.data
            this.loadingKeywords = false
          })
    },
    hoverOnTable() {
      this.showScrollingArrows()
    },
    search() {
      this.fetchFilters()
    }
  },
  created() {
    this.selectedHeaders = this.value
    this.getHeaderForExcel()
    window.addEventListener("resize", this.showScrollingArrows)
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    if (localStorage.getItem('orders')) {
      let orders = JSON.parse(localStorage.getItem('orders'))
      this.dateStart = orders.dateStart
      this.dateEnd = orders.dateEnd
      this.defaultPeriod = orders.defaultPeriod
      this.search = orders.search || ''
      if (orders.report == 'geoSalesReport'
          || orders.report == 'efficiencyReportOtherAdmin'
          || orders.report == 'efficiencyReportOtherUser'
          || orders.report == 'efficiencyReportOtherTotal'
          || orders.report == 'SendInBlueReport'
          || orders.report == 'customerReport'
      ) {
        this.filtered.id = orders.order_ids
      }
      if (orders.report == 'efficiencyReportAdwords'
          || orders.report == 'efficiencyReportBing'
      ) {
        this.filtered.hub_order_id = orders.order_ids
      }
    }

    if (localStorage.getItem('fromCounterPage')) {
      let data = JSON.parse(localStorage.getItem('fromCounterPage'))
      this.dateStart = data.dateStart
      this.dateEnd = data.dateEnd
      this.defaultPeriod = data.defaultPeriod
      localStorage.removeItem('fromCounterPage')
    }

    axios
        .get('/users/me')
        .then(response => {
          this.role = response.data.data.role
          this.rights = response.data.data.rights
          this.managementRight = (this.rights == {}) ? false : this.rights.includes('salesReportAddKeyword')
        })

    axios
        .get('/all/campaigns')
        .then(response => (this.campaigns = response.data.data))

    this.applyFilters()

    let userName = localStorage.getItem('username')
    let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
    if (localStorage.getItem(`${userName}.${clientId}.${this.settingsName}`)) {

      try {
        let valueCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${this.settingsName}`))
        this.value = valueCash.filter(e => this.headers.find(item => item.value === e.value))

        const parsed = JSON.stringify(this.value)
        localStorage.setItem(`${userName}.${clientId}.${this.settingsName}`, parsed)

        this.customHeader = this.value.map(e => e.value)

      } catch (e) {
        console.log("")
      }
    }
    this.showScrollingArrows()
  },
  methods: {
    updateCopperTags(item){
       axios.post('/order/copper/tag', {id: item.id, people_id: item.copper_people_id})
          .then(() => {
            this.applyFilters()
          })
    },
    openLeads(order) {
      this.selectedOrder = order
      this.dialogSettings = true
    },
    cancelLeads() {
      this.dialogSettings = false
    },
    deleteManualKeyword(id, order_id) {
      axios.delete('/mappings/order/keyword/' + id + '/' + order_id)
          .then(() => {
            this.applyFilters(() => {
              this.keywordCampaignForm = this.data.filter(x => x.id === order_id)[0]
            })
          })
    },
    scrollingRight() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow')
      const btnRight = document.querySelector('.btn-right-arrow')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows() {
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    rowClick: function (item, row) {
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    getHeaderForExcel() {
      this.columnsData = this.selectedHeaders.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        if (e.value === "sale_price") {
          obj.label = `${e.text},$`
          obj.field = e.value
        }
        return obj
      }).filter(value => Object.keys(value).length !== 0)
    },
    openEditCopperCompany(item) {
      this.dialogEditCopperCompany = true;
      this.copperCompanynForm = item.copper_company_name
      this.copperCompanynFormId = item.hub_order_id
    },
    closeEditCopperCompany() {
      this.dialogEditCopperCompany = false;
      this.copperCompanynForm = null
    },
    saveEditCopperCompany() {
      this.dialogEditCopperCompany = false;
    },
    openEditKeywordCampaign(item) {
      this.dialogEditKeywordCampaign = true;
      this.keywordCampaignForm = item
    },
    closeEditKeywordCampaign() {
      this.dialogEditKeywordCampaign = false;
      this.keywordCampaignForm = null
      this.keywordCampaignFormCampaignId = null
      this.keywordCampaignFormKeywordId = null
      this.keywords = []
    },
    saveEditKeywordCampaign() {
      this.dialogEditKeywordCampaign = false;
      axios.put('/mappings/order/keyword/' + this.keywordCampaignForm.id + '/' + this.keywordCampaignFormKeywordId)
          .then(() => {
            this.keywordCampaignForm = null
            this.keywordCampaignFormCampaignId = null
            this.keywordCampaignFormKeywordId = null
            this.applyFilters()
          })
    },
    fetchFilters() {
      if (localStorage.getItem('orders')) {
        this.filtered.order_lead_type = this.dataFiltered.reduce((acc, e) => acc.includes(e.order_lead_type) ? acc : [...acc, e.order_lead_type], [])
        this.filtered.order_lead_source = this.dataFiltered.reduce((acc, e) => acc.includes(e.order_lead_source) ? acc : [...acc, e.order_lead_source], [])
        this.filtered.customer_name = this.dataFiltered.reduce((acc, e) => acc.includes(e.customer_name) ? acc : [...acc, e.customer_name], [])
        this.filtered.copper_customer_type = this.dataFiltered.reduce((acc, e) => acc.includes(e.copper_customer_type) ? acc : [...acc, e.copper_customer_type], [])
        this.filtered.customer_type = this.dataFiltered.reduce((acc, e) => acc.includes(e.customer_type) ? acc : [...acc, e.customer_type], [])
        this.filtered.is_created_by_admin = this.dataFiltered.reduce((acc, e) => acc.includes(e.is_created_by_admin) ? acc : [...acc, e.is_created_by_admin], [])
        this.filtered.products = [...new Set(this.dataFiltered.reduce((acc, e) => {
          let products = e.products.reduce((acc, i) => [...acc, i.name], [])
          return [...acc, ...products]
        }, []))
        ]
        this.filtered.color = this.dataFiltered.reduce((acc, e) => acc.includes(e.color) ? acc : [...acc, e.color], [])
        localStorage.removeItem('orders')
      }

      this.update_IsROAS_Show()
      this.statistic.totalOrders = this.data.length
      this.statistic.totalGallons = this._.sumBy(this.data, 'gallons')
      this.statistic.totalSalesPrice = this._.sumBy(this.data, 'sale_price')

      this.statisticFiltered.totalOrders = this.dataFiltered.length
      this.statisticFiltered.totalGallons = this._.sumBy(this.dataFiltered, 'gallons')
      this.statisticFiltered.totalSalesPrice = this._.sumBy(this.dataFiltered, 'sale_price')

      this.filters.leadTypeFilter = [...this.filters.leadTypeFilter, ...this._.compact(this.data
          .map(e => e.order_lead_type)
          .filter((x, i, a) => a.indexOf(x) == i))]
          .sort((a, b) => a.localeCompare(b))

      this.filters.leadSourceFilter = this._.compact(this.data
          .map(e => e.order_lead_source)
          .filter((x, i, a) => a.indexOf(x) == i))
          .sort((a, b) => a.localeCompare(b))
      console.log(this.filters.leadSourceFilter)

      this.filters.customerFilter = this._.compact(this.data
          .map(e => e.customer_name)
          .filter((x, i, a) => a.indexOf(x) == i))
          .sort((a, b) => a.localeCompare(b))

      this.filters.customerType = this._.compact(this.data
          .map(e => e.customer_type)
          .filter((x, i, a) => a.indexOf(x) == i))
          .sort((a, b) => a.localeCompare(b))

      this.filters.createdByAdmin = this._.compact(this.data
          .map(e => e.is_created_by_admin)
          .filter((x, i, a) => a.indexOf(x) == i))
          .sort((a, b) => a.localeCompare(b))

      this.filters.copperCompanyType = this._.compact(this.data
          .map(e => e.copper_customer_type)
          .filter((x, i, a) => a.indexOf(x) == i))
          .sort((a, b) => a.localeCompare(b))

      this.filters.productName = []
      for (let d of this.data) {
        for (let p of d.products) {
          this.filters.productName.push(p.name)
        }
      }

      this.filters.productName = this._.union(this.filters.productName)
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.pagination.page = 1
      this.applyFilters()
    },
    applyFilters(callback = null) {
      this.loaded = true

      axios
          .get('/reports/marketing/sale-report/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {
            this.data = response.data.data
            this.statistic.totalExpenses = response.data.stat.expenses_total_ppc

            this.loaded = false

            this.data.map(e => {
              let empty = ['none', '', null]
              e.uid = e.hub_order_id + e.invoice_id
              e.color = 'blue'
              if (e.leads_kc === null || e.leads_kc.length === 0){
                e.color = 'grey'
                return
              }
              if (e.leads_kc.some(i => (i.internal_keyword_id == 0 || !i.internal_keyword_id) && !empty.includes(i.campaign) && !empty.includes(i.keyword))) {
                e.color = 'red'
              }
              if (e.leads_kc.every(i => (i.internal_keyword_id == 0 || !i.internal_keyword_id) && (empty.includes(i.campaign) || empty.includes(i.keyword)))) {
                e.color = 'grey'
              }
            })
            this.fetchFilters()
            if (callback) {
              callback()
            }
          })
    },
      update_IsROAS_Show(){
          let sel = Object.entries(this.filtered['color']).filter(el=>{
              return el[1] == 'blue';
          })

          if (sel.length >0 ){
              this.isShowROAS = true
          }
          else {
              this.isShowROAS = false
          }
      },
    cleanFilters() {
      this.search = ''

      this.filtered.order_lead_type = []
      this.filtered.order_lead_source = []
      this.filtered.customer_name = []
      this.filtered.copper_customer_type = []
      this.filtered.customer_type = []
      this.filtered.is_created_by_admin = []
      this.filtered.products = []
      this.filtered.id = []
      this.filtered.hub_order_id = []
      this.filtered.color = []
    },
    getCustomData({customHeader, value, selectedHeaders}) {
      this.customHeader = customHeader
      this.value = value
      this.selectedHeaders = selectedHeaders
    }
  },
  computed: {
    dataFiltered() {
      let data = this.data.filter(e => {
        let obj = Object.values(e).map(e => (e && typeof e != 'object') ? e.toString().toLowerCase() : '')
        return obj.some(i => i.match(this.search.toLowerCase()))
      })


      return data.filter(data_item => {
        return Object.keys(this.filtered).every(f => {
          if (Array.isArray(data_item[f])) { // custom filter for product type
            let names = this._.map(data_item[f], p => {
              return p.name
            })
            for (let n of names) {
              if (this.filtered[f].includes(n)) {
                return this.filtered[f].length < 1 || this.filtered[f].includes(n)
              }
            }
          }
          return this.filtered[f].length < 1 || this.filtered[f].includes(data_item[f])
        })
      })
    },
    dataForExcel() {
      if (!this.dataFiltered) return []
      let data = JSON.parse(JSON.stringify(this.dataFiltered))

      for (let i = 0; i < data.length; i++) {
        let products = ""
        if (data[i].products === null) {
          products += `-`
          data[i].products = products
          continue
        }

        for (let p of data[i].products) {
          if (products.length > 0) {
            products += "\n"
          }
          products += `${p.name} - ${p.gallons} gal. `
        }
        data[i].products = products
      }
      return data
    },
    showFilteredStatistic() {
      return Object.values(this.filtered).some(e => e.length) || this.search.length
    }
  }
}
</script>

<style scoped>
.btn-right-arrow {
  right: 0px;
  top: 80px !important;
}

.btn-left-arrow {
  left: 0px;
  top: 80px;
}

.custom-tooltip {
  opacity: 1 !important;
}

.v-chip.v-size--default {
  border-radius: 16px;
  font-size: 11px;
  height: 20px;
}

.v-select.v-input--dense .v-chip {
  margin: 4px 4px 0px 0px;
}

.chip-counter {
  font-size: 10px;
  margin: 4px 0px 0px 0px;
}
</style>
